import { render, staticRenderFns } from "./Trc20.vue?vue&type=template&id=02d1b901&scoped=true"
import script from "./Trc20.vue?vue&type=script&lang=js"
export * from "./Trc20.vue?vue&type=script&lang=js"
import style0 from "./Trc20.vue?vue&type=style&index=0&id=02d1b901&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "02d1b901",
  null
  
)

export default component.exports